import { faEdit, faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Button } from "@themesberg/react-bootstrap";
import manAvatar from "../../assets/manAvatar.webp";

const ProfileCardWidget = ({
	user,
	handleAddEditCloseButtonClick,
	handleDeleteButtonClick,
	setAddEditButtonClicked,
}) => {
	console.log(user);

	return (
		<Card border="light" className="text-center p-0 mb-4">
			<div className="bg-primary profile-cover rounded-top" />
			<Card.Body className="pb-5">
				<Card.Img
					src={manAvatar}
					alt="Neil Portrait"
					className="user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4"
				/>
				<Card.Title>{user?.name}</Card.Title>
				<Card.Subtitle className="fw-normal">
					Property owned: <span className="text-bolder">{user?.properties?.length}</span>
				</Card.Subtitle>
				<Card.Text className="text-gray mb-4">
					Email: {user?.email}
					<br />
					Phone: {user?.phone}
				</Card.Text>

				<Button
					variant="primary"
					size="sm"
					className="me-2"
					onClick={() => {
						setAddEditButtonClicked(true);
						handleAddEditCloseButtonClick(true);
					}}
				>
					<FontAwesomeIcon icon={faEdit} className="me-1" /> Edit
				</Button>

				<Button
					variant="danger"
					size="sm"
					className="me-2"
					onClick={() => {
						handleDeleteButtonClick();
					}}
				>
					<FontAwesomeIcon icon={faUserSlash} className="me-1" /> Delete
				</Button>
			</Card.Body>
		</Card>
	);
};

export default ProfileCardWidget;
